import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address-state"
// Swaps the free-text "State or region" input for a US state dropdown when the
// Country is the United States, and back to free text for any other country.
// Both controls are bound to the same `state` attribute; the inactive one is
// disabled so only one value is submitted.
export default class extends Controller {
  static targets = ["country", "textWrapper", "textInput", "selectWrapper", "selectInput"]

  declare readonly countryTarget: HTMLSelectElement
  declare readonly textWrapperTarget: HTMLElement
  declare readonly textInputTarget: HTMLInputElement
  declare readonly selectWrapperTarget: HTMLElement
  declare readonly selectInputTarget: HTMLSelectElement

  private previousIsUS = false

  connect() {
    this.previousIsUS = this.isUS
    this.applyVisibility()
  }

  toggle() {
    // Only carry a value across when the active control actually switches
    // (i.e. we cross the US boundary). The latest entry from the control that
    // was active always wins — never a stale value left in the other control.
    if (this.isUS && !this.previousIsUS) {
      this.selectInputTarget.value = this.textInputTarget.value
    } else if (!this.isUS && this.previousIsUS) {
      this.textInputTarget.value = this.selectInputTarget.value
    }
    this.previousIsUS = this.isUS
    this.applyVisibility()
  }

  private get isUS(): boolean {
    return this.countryTarget.value === "US"
  }

  private applyVisibility() {
    if (this.isUS) {
      this.show(this.selectWrapperTarget, this.selectInputTarget)
      this.hide(this.textWrapperTarget, this.textInputTarget)
    } else {
      this.show(this.textWrapperTarget, this.textInputTarget)
      this.hide(this.selectWrapperTarget, this.selectInputTarget)
    }
  }

  private show(wrapper: HTMLElement, input: HTMLInputElement | HTMLSelectElement) {
    wrapper.classList.remove("hidden")
    input.disabled = false
  }

  private hide(wrapper: HTMLElement, input: HTMLInputElement | HTMLSelectElement) {
    wrapper.classList.add("hidden")
    input.disabled = true
  }
}
